import z from "zod";
import type { EmitEventInput } from "@remi/types/event-store";

import { ErrorClassification } from "../../../sentry/classification";
import type { ErrorDetails } from "../domain";

const eventStoreErrorTypeValues = ["EVENT_VALIDATION_FAILED", "ORG_ISOLATION_VIOLATION"] as const;
const eventStoreErrorTypeSchema = z.enum(eventStoreErrorTypeValues);
const EventStoreErrorType = eventStoreErrorTypeSchema.enum;
type EventStoreErrorType = z.infer<typeof eventStoreErrorTypeSchema>;

export type EventStoreErrors =
  | {
      errorType: typeof EventStoreErrorType.EVENT_VALIDATION_FAILED;
      // eventInput is the full intended payload so a rejected event can be reconstructed and re-emitted.
      data: { zodErrors: string; eventInput: EmitEventInput };
    }
  | {
      errorType: typeof EventStoreErrorType.ORG_ISOLATION_VIOLATION;
      data: { queryName: string; providedFilters: string[] };
    };

export const eventStoreErrorDetails: Record<EventStoreErrorType, ErrorDetails> = {
  EVENT_VALIDATION_FAILED: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Event payload failed Zod validation",
  },
  ORG_ISOLATION_VIOLATION: {
    classification: ErrorClassification.AUTHORIZATION_ERROR,
    sentryDescription: "Event store query attempted without org isolation",
  },
};
